<template>
  <div>
    <h5
      style="
        display: flex;
        justify-content: center;
        font-weight: 400;
        padding-top: 10px;
        padding-bottom: 30px;
      "
    >
      Create Distribution Center
    </h5>
    <a-form-model
      ref="centerForm"
      :model="form"
      :rules="rules"
      :wrapper-col="wrapperCol"
      @submit.prevent="handleSubmit"
      style="margin: mx-auto"
    >
      <a-row>
        <a-col :span="22" :offset="1">
          <a-form-model-item label="Center's Name:" ref="name" prop="name">
            <a-input
              placeholder="Distribution Center Name"
              v-model="form.name"
              @blur="
                () => {
                  $refs.name.onFieldBlur();
                }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="22" :offset="1">
          <a-form-model-item label="Center's Address:" ref="address" prop="address">
            <a-input
              placeholder="Distribution Center Address"
              v-model="form.address"
              @blur="
                () => {
                  $refs.address.onFieldBlur();
                }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="22" :offset="1">
          <a-form-model-item label="Center's Type:" ref="type" prop="type">
            <a-select  v-model="form.type" placeholder="please select your option">
                <a-select-option value="0">
                    Physical
                </a-select-option> 
                <a-select-option value="1">
                    Virtual
                </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-form-model-item
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 10px;
        "
      >
        <a-row>
            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                    <a-spin class="spinner" :spinning="loading" />
            </div>
          <a-col :span="22" :offset="6">
            <a-button
              @click="handleSubmit"
              style="
                background: #418a49;
                height: 50px;
                color: #fff;
                width: 263px;
                border-radius: 5px;
              "
            >
              Create & Save
            </a-button>
          </a-col>
        </a-row>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: "CreateDistroCenter",
  data: () => ({
    loading: false,
    form: {
      name: "",
      address: "",
      type: "0"
    },
    labelCol: { span: 6 },
    wrapperCol: { span: 24 },
    rules: {
      name: {
        required: true,
        message: "Center's name is required",
        trigger: "blur",
      },
      address: {
        required: true,
        message: "Center's address is required",
        trigger: "blur",
      },
      type: {
        required: true,
        message: "Center's type is required",
        trigger: "blur",
      },
    },
  }),
  methods: {
    handleSubmit() {
      this.$refs.centerForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const res = await this.$store.dispatch("distroCenter/CreateDistroCenter", this.form);
          if(res.code === 201) {
            this.loading = false
            this.$notification[res.status]({
                message: 'Successfully created distribution center.'
            });
            location.reload();
          }else {
            this.$notification[res.status]({
                message: 'Error creating center'
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-form-item-label {
  display: block;
}
</style>